(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["common-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const heroRating = document.querySelector('.js-hero .js-rating');
    if (!heroRating) return;

    const productId = heroRating.dataset.productId;
    const reviewsPerPage = heroRating.dataset.reviewsPerPage;
    const reviewsData = await window.newpage?.fetchProductRating?.(productId, reviewsPerPage);
    if (!reviewsData) return;

    heroRating.insertAdjacentHTML(
      'afterbegin',
      `<span style="--stars: ${reviewsData.bottomline.average_score}" class="star5"></span>
       <span class="hero--rating-value"><span>${reviewsData.bottomline.average_score.toFixed(1)}</span>/5</span>`
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["common-newpage-default"]) return;
  try {
    
  window.newpage = window.newpage || {};

  window.newpage.fetchProductRating = async (productId, reviewsPerPage) => {
    if (!productId || !reviewsPerPage) return null;

    try {
      const options = {
        endpoint: 'https://api-cdn.yotpo.com/v1/widget/$app_key/products/$product_id/reviews.json',
        appkey: 'APNWxX3ImKb8kANkD7teFi4D8AlckZkL6tT7dKX8',
      };
      const url =
        options.endpoint.replace('$app_key', options.appkey).replace('$product_id', productId) +
        '?per_page=' +
        reviewsPerPage;

      const response = await fetch(url);

      if (!response.ok) {
        throw Error(response.statusText);
      }
      const data = await response.json();
      if ('status' in data && data.status.code == 200 && 'response' in data) {
        return data.response;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  window.newpage.initVideoPlayers = () => {
    const videoWrappers = document.querySelectorAll('.js-video');

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      const pause = wrapper.querySelector('.js-video-playpause');
      const mute = wrapper.querySelector('.js-video-volume');

      pause.addEventListener('click', () => {
        if (video.paused || video.ended) {
          video.play();
          pause.classList.add('entypo-controller-paus');
          pause.classList.remove('entypo-controller-play');
        } else {
          video.pause();
          pause.classList.add('entypo-controller-play');
          pause.classList.remove('entypo-controller-paus');
        }
      });
      mute.addEventListener('click', () => {
        video.muted = !video.muted;
        mute.classList.toggle('fa-controller-volume-up', video.muted);
        mute.classList.toggle('fa-controller-volume-off', !video.muted);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.newpage.initVideoPlayers();
  });

  } catch(e) { console.error(e); }
})();
})();
